import React, { useMemo } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { SupersetDashboard } from '../components/Reports/Dashboard';
import { useLoader } from '@akcelita/uwe-core';
// Local Tailwind Notification — the package version wraps reactstrap.Alert
// and emits Bootstrap markup that bypasses theme tokens.
import Notification from '../components/Notification';
import Loader from '../components/Loader';
import ReportsApi from '../api/ReportsApi';

export default function DashboardView() {
  const { dashboardUuid } = useParams();
  const location = useLocation();
  // Parse query params for UI config
  const queryParams = useMemo(() => {
    // Security: Read constraints from sessionStorage
    const storageKey = `superset_constraints_${dashboardUuid}`;
    const constraintsRaw = sessionStorage.getItem(storageKey);
    let constraints = undefined;

    if (constraintsRaw) {
        try {
            constraints = JSON.parse(constraintsRaw);
            // Clear immediately after reading
            sessionStorage.removeItem(storageKey);
        } catch (e) {
            console.error("Failed to parse constraints from sessionStorage", e);
        }
    }
    
    return {
        constraints
    };
  }, [location.search, dashboardUuid]);

  const {
     constraints,
  } = queryParams;

  const [loading, error, loadFn] = useLoader();
  const [tokenData, setTokenData] = React.useState(null);

  React.useEffect(() => {
    if (dashboardUuid) {
      loadFn(async () => {
        const result = await ReportsApi.getDashboardEmbedToken({ dashboardUuid, constraints });
        setTokenData(result);
      });
    }
  }, [dashboardUuid, constraints, loadFn]);


  if (!dashboardUuid) {
    return <Notification error="Dashboard UUID is missing." />;
  }

  if (loading) {
    return <Loader fullscreen />;
  }

  if (error) {
     const errorMsg = error?.errors?.[0]?.message || error.message || JSON.stringify(error);
     return <Notification error={`Error loading dashboard: ${errorMsg}`} />;
  }

  if (!tokenData) {
    return null; 
  }

  return (
    <div style={{ width: '100vw', height: '100vh', overflow: 'hidden' }}>
        <SupersetDashboard
        dashboardUuid={dashboardUuid}
        token={tokenData.token}
        url={tokenData.url}
        height={'100vh'}
        hideTitle={true}
        hideTab={true}
        hideChartControls={false}
        />
    </div>
  );
}